import type {CohortADto} from '@cohort/admin-schemas/cohort';

export const isList = (cohort: CohortADto): boolean => {
  return cohort.type === 'list';
};
